import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Layout } from 'antd';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import HeaderComponent from './HeaderComponent';
import DashboardMenu from '../../components/DashboardMenu/DashboardMenu';
import styled from 'styled-components';
import LoadingComponent from '../../components/Loading/LoadingComponent';
import LoadingPage from '../../components/Loading/LoadingPage';
import NewUpdateModal from '../../components//NewUpdateModal/NewUpdateModal';
import { device } from '../../styles/Responsive';

const Section = styled.div`
  padding: 80px;
  margin-left: 280px;
  margin-top: 100px;
  position: relative;

  @media ${device.laptop} {
    margin-left: 220px;
    padding: 40px;
  }

  @media ${device.tablet} {
    margin-left: 0;
    margin-top: 60px;
    padding-bottom: 100px;
  }
`;

const Router = ({ component: C, props: cProps, ready, ...rest }) => {
  if (localStorage.getItem(process.env.REACT_APP_AUTH_TOKEN)) {
    return (
      <Route
        {...rest}
        render={props => (
          <Layout>
            {!ready && <LoadingPage />}
            <HeaderComponent />
            <DashboardMenu />
            <Section>
              <C {...props} {...cProps} />
            </Section>
            <ToastContainer />
            <LoadingComponent />
            <NewUpdateModal />
          </Layout>
        )}
      />
    );
  }

  return <Redirect to={'/'} />;
};

const mapStateToProps = state => ({
  ready: state.info.ready
});

export default connect(mapStateToProps)(Router);



// WEBPACK FOOTER //
// ./src/pages/layout/AuthenticatedLayout.js